import { PRIMARY_COLOR, SECONDARY_COLOR } from "../../color-constants";

const standardize_color = (str) => {
  var ctx = document.createElement('canvas').getContext('2d');
  ctx.fillStyle = str;
  return ctx.fillStyle.length > 0 && ctx.fillStyle[0] === '#' ? ctx.fillStyle : rgb2hex(ctx.fillStyle);
}

function rgb2hex(rgb) {
  rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  return (rgb && rgb.length === 4) ? "#" +
    ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
    ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
    ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
}

const hexToRgb = hex =>
  hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
    , (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1).match(/.{2}/g)
    .map(x => parseInt(x, 16));


function rgb_is_light(color) {
  const brightness = ((color[0] * 299) + (color[1] * 587) + (color[2] * 114)) / 1000;
  return brightness > 155;
}

export const generateDistributorColors = (distributorColor, distributorSecondaryColor) => {
  let colors = {
    primaryColor: distributorColor || PRIMARY_COLOR,
    secondaryColor: distributorSecondaryColor || SECONDARY_COLOR,

    hoverColor: PRIMARY_COLOR,
    textColor: 'white',
    hoverTextColor: 'white',
    secondaryTextColor: 'white',
    secondaryHoverColor: '#0087CD',
    secondaryHoverTextColor: 'white'
  }
  try {
    const standardizedColor = standardize_color(distributorColor);
    const standardizedSecondaryColor = standardize_color(distributorSecondaryColor);
    const rgb = hexToRgb(standardizedColor);
    const rgbSecondary = hexToRgb(standardizedSecondaryColor);
    const colorWithFilter = [Math.max(rgb[0] - 30, 0), Math.max(rgb[1] - 30, 0), Math.max(rgb[2] - 30, 0)];
    const secondaryColorWithFilter = [Math.max(rgbSecondary[0] - 30, 0), Math.max(rgbSecondary[1] - 30, 0), Math.max(rgbSecondary[2] - 30, 0)];
    colors.hoverColor = `rgb(${colorWithFilter[0]},${colorWithFilter[1]},${colorWithFilter[2]})`;
    colors.secondaryHoverColor = `rgb(${secondaryColorWithFilter[0]},${secondaryColorWithFilter[1]},${secondaryColorWithFilter[2]})`;
    if (rgb_is_light(rgb)) {
      colors.textColor = 'rgb(98,100,105)';
    }
    if (rgb_is_light(colorWithFilter)) {
      colors.hoverTextColor = 'rgb(98,100,105)';
    }
    if (rgb_is_light(rgbSecondary)) {
      colors.secondaryTextColor = 'rgb(98,100,105)';
    }
    if (rgb_is_light(secondaryColorWithFilter)) {
      colors.secondaryHoverTextColor = 'rgb(98,100,105)';
    }
  } catch (error) {
    console.log(error);
  }
  return colors;
}
